module.exports = {
  api: {
    lpc: {
      host: 'https://www.kupibilet.ru/api/lpc',
      timeout: 6000,
    },
    directions: {
      host: 'https://directions.kupibilet.ru',
      timeout: 3000,
    },
    suggest: {
      host: 'https://hinter.kupibilet.ru',
      timeout: 6000,
    },
    geo: {
      host: 'https://geo.kupibilet.ru',
      timeout: 6000,
    },
    hotels: {
      host: 'https://hotels-api.kupibilet.ru',
      timeout: 6000,
    },
    imgproxy: {
      host: 'https://imgproxy.kupibilet.ru',
    },
    analytics: {
      host: 'https://a.kupibilet.ru',
      timeout: 6000,
      token: '449a4a50-a390-4812-ab61-863bb55a9712',
    },
    sendSms: {
      // host: 'https://mobile-link-sender.kupibilet.ru',
      host: 'https://3bb5cb78-b3d2-4e78-a9a3-ef2d1217945e.kupibilet.ru',
      timeout: 6000,
    },
    client_info: {
      host: 'https://www.kupibilet.ru/api/get_client_info',
      timeout: 12000,
    },
  },
}
